module.exports = __webpack_public_path__ + "174d24b578ecab96e381a403334b4a24.svg";